const settle = <T>(promises: Promise<T>[]): Promise<{ successful: T[]; failed: unknown[] }> => {
  const resolutions: T[] = [];
  const rejections: unknown[] = [];

  const wait = Promise.all(
    promises.map((promise) => {
      return promise.then(
        (value) => {
          resolutions.push(value);
        },
        (error) => {
          rejections.push(error);
        },
      );
    }),
  );
  return wait.then(() => {
    return {
      successful: resolutions,
      failed: rejections,
    };
  });
};

export default settle;
